import { Button, Input, message, Popover, Select, Skeleton, Space, Typography } from 'antd';
import * as ROOMS_SERVICES from "api/services/rooms/rooms.services";
import { FLAGS, StatusCode, UserRoles } from 'common/enums';
import AppResult from 'components/appResults';
import CercleChart from 'components/barChart/cercleChart';
import ChallengeChart from 'components/challengeCharts';
import HelpPopover from 'components/help';
import TeacherCollectiveCalendar from 'components/TeacherCollectiveCalendar';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CardContribution from 'screens/teacher/components/cardContribution';
import { setChatReceiverId, setSelectUserChat, toggleAppChat } from 'store/AppChat/appChat';
import { useFindRoomMutation } from 'store/services/chat';
import { useGetHistoriqueOrganismQuery, useGetHistoriqueQuery, useGetHistoriqueStudentQuery, useGetTeacherReservationsByClassQuery } from 'store/services/teacher/classes.services';
import StudentAvatar from "../../../assets/images/app/iam_student.svg";
import OptionsIcon from "../../../assets/images/app/options_icon.svg";
import SearchIcon from "../../../assets/images/app/search.svg";
import SessionsCalendarGridView from '../SessionsCalendarGridView/SessionsCalendarGridView';
import SessionsListView from '../SessionsListView/SessionsListView';
import StudentsGridView from '../StudentsGridView/StudentsGridView';
import TeacherAvailability from '../TeacherAvailability/TeacherAvailability';
import { CourseViewType, ViewType } from '../types';
import './GroupClassesContent.css';

const { Title } = Typography;
const { Search } = Input;
const { Option } = Select;

interface GroupClassesContentProps {
  data: any;
  students: any[];
  viewType: ViewType;
  publicationData: any;
  onViewChange?: (view: ViewType) => void;
  onInviteStudent?: () => void;
  onShowHistory?: () => void;
  onAddPublication?: () => void;
  onSelectChallenge?: (id: string) => void;
  pieData?: any;
  barData?: any;
  challenges?: any;
  challengePercentage?: any;
  challengeStudents?: any;
  onNewAction?: () => void;
  onDisplayChallengesHistory?: () => void;
  isFetchingChallengeData?: boolean;
}

const GroupClassesContent: React.FC<GroupClassesContentProps> = ({
  data,
  students,
  viewType,
  publicationData,
  onViewChange,
  onInviteStudent,
  onShowHistory,
  onAddPublication,
  onSelectChallenge,
  pieData,
  barData,
  challenges,
  challengePercentage,
  challengeStudents,
  onNewAction,
  onDisplayChallengesHistory,
  isFetchingChallengeData
}) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { isReservationsUpdated } = useSelector((state) => state.app);
  const [studentId, setStudentId] = useState();
  const [filteredStudents, setFilteredStudents] = useState<any>();
  /* const [bookingFilterType, setBookingFilterType] = useState<string>('thisClass'); */
  /* const [teacherBooking, setTeacherBooking] = useState<any>(); */
  const [filteredChallengeStudents, setFilteredChallengeStudents] = useState<any>();
  const [courseView, setCourseView] = useState<CourseViewType>('list');

  const [isLoading, setIsLoading] = useState(false);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const [findRoom, { data: dataFindRoom, isSuccess }] = useFindRoomMutation();

  const [visibleOptions, setVisibleOptions] = useState(false);
  const popoverReportRef = useRef<HTMLDivElement>(null);

  const [calendarData, setCalendarData] = useState<any>();
  const [loadingCalendarData, setLoadingCalendarData] = useState<boolean>(true);
  const [collectiveCalendarData, setCollectiveCalendarData] = useState<any>();
  const [isCollective, setIsCollective] = useState<boolean>(false);

  const [filterOrganism, setFilterOrganism] = useState<string | undefined>(undefined);
  const [filter, setFilter] = useState<string | undefined>(undefined);
  const [filteredReservations, setFilteredReservations] = useState<any>();
  const [filteredReservationsStudent, setFilteredReservationsStudent] = useState<any>();
  const [filteredOrganismReservations, setFilteredOrganismReservations] = useState<any>();

  /* const {
    data: reservations,
    isLoading: isLoadingReservations,
    isError,
    refetch,
  } = useGetHistoriqueOrganismByClassQuery({ userId: user?._id, classId: data?._id }); */

  const {
    data: reservations,
    isLoading: isLoadingReservations,
    isError,
    refetch,
  } = useGetHistoriqueOrganismQuery({ organismeId: user?._id });

  const {
    data: teacherReservations,
    isLoading: isLoadingReservationsTeacher,
    isError: isErrorTeacher,
    refetch: refetchReservationsTeacher,
  } = useGetHistoriqueQuery(user?._id);

  const {
    data: teacherReservationsByClass,
    isLoading: isLoadingTeacherReservationsByClass,
    isError: isErrorTeacherReservations,
    refetch: refetchTeacherReservation,
  } = useGetTeacherReservationsByClassQuery({ profId: user?._id, classeId: data?._id });

  const {
    data: studentReservations,
    isLoading: isLoadingReservationsStudent,
    isError: isErrorStudent,
    refetch: refetchReservationsStudent,
  } = useGetHistoriqueStudentQuery(user?._id);

  const handleFilteringStudents = (e: any) => {

    const value = e.target.value.toLowerCase();

    if (value !== undefined) {
      if (viewType === "challenges") {
        const filtered = value
          ? filteredChallengeStudents.filter((student: any) =>
            student.fullname?.toLowerCase().includes(value.toLowerCase())
          )
          : challengeStudents;
        setFilteredChallengeStudents(filtered);
      }
      else {
        const filtered = value
          ? filteredStudents.filter((data: any) =>
            data?.student.firstname?.toLowerCase().includes(value) ||
            data?.student.lastname?.toLowerCase().includes(value)
          )
          : students;

        setFilteredStudents(filtered);
      }
    }
  };

  const handleInvite = () => {
    onInviteStudent!();
  };

  const handleAddPublication = () => {
    onAddPublication!();
  };

  const handleDeleteStudent = async (id: string) => {
    setIsLoading(true);
    try {
      setIsLoading(true);
      const response = await ROOMS_SERVICES.removeStudentFromClass(data?.accessCode, id);
      if (response?.statusCode === StatusCode.OK) {
        setFilteredStudents((prev: any[]) =>
          prev?.filter((data: any) => data?.student._id !== id)
        );
        message.success("Élève supprimé avec succès.");
        onNewAction!();
      }
    } catch (error: any) {
      console.log(error);
      message.warning("Erreur survenue lors de la suppression, merci de réessayer.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleChallengesHistory = () => {
    onDisplayChallengesHistory!();
  };

  const handleSendMessage = () => {
    const findRoomBody = {
      actor1: user?._id,
      actor2: studentId,
      flag: FLAGS.SINGLE_FLAG,
      instaprof: "",
      type: "",
    };

    console.log(findRoomBody);

    findRoom(findRoomBody);
    dispatch(setChatReceiverId(studentId));
  };

  const handleClickOutside = (event: MouseEvent) => {
    setTimeout(() => {
      if (popoverReportRef.current && !popoverReportRef.current.contains(event.target as Node)) {
        setVisibleOptions(false);
      }
    }, 200);
  };

  const content = (
    <div onClick={(e) => e.stopPropagation()}>
      <div onClick={handleSendMessage} style={{ fontSize: "1em", color: "#F56666" }}>Envoyer un message</div>
    </div>
  );

  const handleFilter = (value: string) => {
    setFilter(value);

    if (!value) {
      setFilteredReservations(teacherReservations?.data);
      return;
    }

    let filtered = teacherReservations?.data;

    if (value === "thisClass") {
      // Cette classe
      filtered = teacherReservations?.data.filter(
        (reservation: any) =>
          reservation.classeId &&
          data?._id &&
          reservation.classeId === data._id
      );
    }

    if (value === "otherClasses") {
      // Mes autres classes (collectives, mais pas cette classe)
      filtered = teacherReservations?.data.filter(
        (reservation: any) =>
          /* reservation.isCollective === true && */
          reservation.classeId &&
          data?._id &&
          reservation.classeId !== data._id
      );
    }

    if (value === "particular") {
      // Mes cours particuliers
      filtered = teacherReservations?.data.filter(
        /* (reservation: any) => reservation.isCollective === false || reservation.isCollective === undefined */
        (reservation: any) => reservation.classeId === "" || reservation.classeId === undefined
      );
    }

    setFilteredReservations(filtered);
  };

  const handleFilterStudent = (value: string) => {
    setFilter(value);

    if (!value) {
      setFilteredReservationsStudent(studentReservations?.data);
      return;
    }

    let filtered = studentReservations?.data;

    if (value === "thisClass") {
      // Cette classe
      filtered = studentReservations?.data.filter(
        (reservation: any) =>
          reservation.classeId &&
          data?._id &&
          reservation.classeId === data._id
      );
    }

    if (value === "otherClasses") {
      // Mes autres classes (collectives, mais pas cette classe)
      filtered = studentReservations?.data.filter(
        (reservation: any) =>
          /* reservation.isCollective === true && */
          reservation.classeId &&
          data?._id &&
          reservation.classeId !== data._id
      );
    }

    if (value === "particular") {
      // Mes cours particuliers
      filtered = studentReservations?.data.filter(
        /* (reservation: any) => reservation.isCollective === false || reservation.isCollective === undefined */
        (reservation: any) => reservation.classeId === "" || reservation.classeId === undefined || reservation.classeId === null
      );
    }

    if (value === "all") {
      // Mes cours particuliers
      filtered = studentReservations?.data;
    }

    setFilteredReservationsStudent(filtered);
  };

  const handleFilterOrganism = (value: string) => {
    setFilterOrganism(value);

    if (!value) {
      setFilteredOrganismReservations(reservations?.data);
      return;
    }

    let filtered = reservations?.data;

    if (value === "thisClass") {
      // Cette classe
      filtered = reservations?.data.filter(
        (reservation: any) =>
          reservation.classeId &&
          data?._id &&
          reservation.classeId === data._id
      );
    }

    if (value === "otherClasses") {
      // Mes autres classes (collectives, mais pas cette classe)
      filtered = reservations?.data.filter(
        (reservation: any) =>
          /* reservation.isCollective === true && */
          reservation.classeId &&
          data?._id &&
          reservation.classeId !== data._id
      );
    }

    if (value === "particular") {
      // Mes cours particuliers
      filtered = reservations?.data.filter(
        /* (reservation: any) => reservation.isCollective === false || reservation.isCollective === undefined */
        (reservation: any) => reservation.classeId === "" || reservation.classeId === undefined
      );
    }

    setFilteredOrganismReservations(filtered);
  };

  useEffect(() => {
    setCourseView('list');
  }, [viewType]);

  useEffect(() => {
    console.log("New Is Collective", isCollective);
  }, [isCollective]);

  useEffect(() => {
    refetch();
    refetchReservationsTeacher();
    refetchTeacherReservation();
    refetchReservationsStudent();
  }, [isReservationsUpdated]);

  useEffect(() => {
    if (students) {
      setFilteredStudents(students);
    }
  }, [students]);

  useEffect(() => {
    if (challengeStudents) {
      setFilteredChallengeStudents(challengeStudents);
    }
  }, [challengeStudents]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [visibleOptions]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(setSelectUserChat(true));
      dispatch(toggleAppChat(true));
    }
  }, [isSuccess]);

  useEffect(() => {
    if (data) {
      setIsCollective(data?.isCollective);
    }
  }, [data]);

  useEffect(() => {
    if (teacherReservations) {
      setFilteredReservations(teacherReservations?.data);
    }
  }, [teacherReservations]);

  useEffect(() => {
    if (reservations) {
      setFilteredOrganismReservations(reservations?.data);
    }
  }, [reservations]);

  useEffect(() => {
    if (studentReservations) {
      setFilteredReservationsStudent(studentReservations?.data);
    }
  }, [studentReservations]);

  // Students tab - grid view
  if (viewType === 'grid') {
    return (
      <div className="group-classes-content">
        <div className="content-header">
          <Space className="content-header-title-box">
            <Space className="content-header-title">
              <Title level={4} style={{ margin: 0 }}>
                Les élèves
              </Title>
              <HelpPopover id={"classe"} />
            </Space>

            <div className="search-box">
              <Input
                placeholder="Chercher un élève..."
                onChange={handleFilteringStudents}
                style={{ maxWidth: 400, borderRadius: "16px !important" }}
                size="large"
                bordered={false}
              />
              <img src={SearchIcon} height={15} />
            </div>
          </Space>

          {user?.roles?.includes(UserRoles?.ORGANISME) && data?.status === "PUBLISHED" && <Button
            type="primary"
            size="middle"
            onClick={handleInvite}
            className="classBtn classBtn-green"
            style={{ width: "150px" }}
          >
            Ajouter un élève
          </Button>}
        </div>

        {filteredStudents && <StudentsGridView
          students={filteredStudents}
          onDeleteStudent={handleDeleteStudent}
          isLoading={isLoading}
        />}
      </div>
    );
  }

  // Courses tab - list or calendar view
  else if (viewType === 'calendar') {
    return (
      <div className="group-classes-content">
        <div className="content-header">
          {isMobile ? <Space style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: 'center', width: '100%' }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: 'center', width: '100%' }}>
              <Space>
                <Title level={4} style={{ margin: 0 }}>
                  Cours réservés
                </Title>
                <HelpPopover id={"classe"} />
              </Space>

              <Button
                type="primary"
                size="middle"
                onClick={onShowHistory}
                className="classBtn classBtn-green"
                style={{ width: "150px" }}
              >
                Historique
              </Button>
            </div>

            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'center', width: '100%', margin: "10px auto", gap: "10px" }}>
              <Space>
                {courseView === 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('list')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue par liste
                </Button>}
                {courseView !== 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('calendar')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue calendrier
                </Button>}
              </Space>

              {courseView !== 'calendar' && <Select
                value={filterOrganism}
                onChange={(value) => handleFilterOrganism(value)}
                allowClear
                className="view-select-filter"
                placeholder={"Filtrer"}
              >
                <Option value="thisClass">Cette classe</Option>
                <Option value="otherClasses">Mes autres classes</Option>
                {!user?.roles?.includes(UserRoles?.ORGANISME) && <Option value="particular">Mes cours particuliers</Option>}
              </Select>}
            </div>
          </Space> : <Space style={{ justifyContent: 'space-between', width: '100%', flexWrap: 'wrap' }}>
            <Space style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'flex-start' }}>
              <Space>
                <Title level={4} style={{ margin: 0 }}>
                  Cours réservés
                </Title>
                <HelpPopover id={"classe"} />
              </Space>
              <Space>
                {courseView === 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('list')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue par liste
                </Button>}
                {courseView !== 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('calendar')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue calendrier
                </Button>}
              </Space>

              {courseView !== 'calendar' && <Select
                value={filterOrganism}
                onChange={(value) => handleFilterOrganism(value)}
                allowClear
                className="view-select-filter"
                placeholder={"Filtrer"}
              >
                <Option value="thisClass">Cette classe</Option>
                <Option value="otherClasses">Mes autres classes</Option>
                {!user?.roles?.includes(UserRoles?.ORGANISME) && <Option value="particular">Mes cours particuliers</Option>}
              </Select>}
            </Space>

            <Button
              type="primary"
              size="middle"
              onClick={onShowHistory}
              className="classBtn classBtn-green"
              style={{ width: "150px" }}
            >
              Historique
            </Button>
          </Space>}
        </div>

        {courseView === 'list' ? (
          isLoadingReservations ? <Skeleton /> : !isLoadingReservations && filteredOrganismReservations?.length > 0 ? <SessionsListView
            sessions={filteredOrganismReservations}
            teacher={data?.teacher}
          /> : <AppResult status={"info"} title={"Aucune séance"}></AppResult>
        ) : (
          reservations?.data?.length > 0 ? <SessionsCalendarGridView
            sessions={reservations?.data}
            data={data}
            showFilter={true}
            showParticular={false}
            showAll={false}
          /> : <AppResult status={"info"} title={"Aucune séance"}></AppResult>
        )}
      </div>
    );
  }

  // Publications tab - publications view
  else if (viewType === 'publications') {
    return (
      <div className="group-classes-content">
        <div className="content-header">
          <Space className="content-header-title-box">
            <Space className="content-header-title">
              <Title level={4} style={{ margin: 0 }}>
                Publications
              </Title>
              <HelpPopover id={"classe"} />
            </Space>
          </Space>

          {!user?.roles?.includes(UserRoles?.STUDENT) && data?.status === "PUBLISHED" && <Button
            type="primary"
            size="middle"
            onClick={handleAddPublication}
            className="classBtn classBtn-green"
            style={{ width: "200px" }}
          >
            + Ajouter une publication
          </Button>}
        </div>

        {publicationData?.results.length > 0 ? (
          <div style={{ padding: "10px 25px" }}>
            {publicationData?.results?.map((contribution: any, i: number) => (
              <CardContribution key={i} contribution={contribution} />
            ))}
          </div>
        ) : (
          <AppResult status="info" title="Aucune publication" />
        )}
      </div>
    );
  }

  // Teacher Booking tab - Booking view
  else if (viewType === 'calendarBooking') {
    return (
      <div className="group-classes-content">
        <div className="content-header">
          {isMobile ? <Space style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: 'center', width: '100%' }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: 'center', width: '100%' }}>
              <Space>
                <Title level={4} style={{ margin: 0 }}>
                  Cours réservés
                </Title>
                <HelpPopover id={"classe"} />
              </Space>

              <Button
                type="primary"
                size="middle"
                onClick={onShowHistory}
                className="classBtn classBtn-green"
                style={{ width: "150px" }}
              >
                Historique
              </Button>
            </div>

            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'center', width: '100%', margin: "10px auto" }}>
              <Space>
                {courseView === 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('list')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue par liste
                </Button>}
                {courseView !== 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('calendar')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue calendrier
                </Button>}
              </Space>

              {courseView !== 'calendar' && <Select
                value={filter}
                onChange={(value) => handleFilter(value)}
                allowClear
                className="view-select-filter"
                placeholder={"Filtrer"}
              >
                <Option value="thisClass">Cette classe</Option>
                <Option value="otherClasses">Mes autres classes</Option>
                <Option value="particular">Mes cours particuliers</Option>
              </Select>}
            </div>
          </Space> : <Space style={{ justifyContent: 'space-between', width: '100%', flexWrap: 'wrap' }}>
            <Space style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'flex-start' }}>
              <Space>
                <Title level={4} style={{ margin: 0 }}>
                  Cours réservés
                </Title>
                <HelpPopover id={"classe"} />
              </Space>
              <Space>
                {courseView === 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('list')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue par liste
                </Button>}
                {courseView !== 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('calendar')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue calendrier
                </Button>}
              </Space>

              {courseView !== 'calendar' && <Select
                value={filter}
                onChange={(value) => handleFilter(value)}
                allowClear
                className="view-select-filter"
                placeholder={"Filtrer"}
              >
                <Option value="thisClass">Cette classe</Option>
                <Option value="otherClasses">Mes autres classes</Option>
                <Option value="particular">Mes cours particuliers</Option>
              </Select>}
            </Space>

            <Button
              type="primary"
              size="middle"
              onClick={onShowHistory}
              className="classBtn classBtn-green"
              style={{ width: "150px" }}
            >
              Historique
            </Button>
          </Space>}
        </div>

        {courseView === 'list' ? (
          isLoadingReservationsTeacher ? <Skeleton /> : !isLoadingReservationsTeacher && filteredReservations?.length > 0 ? <SessionsListView
            sessions={filteredReservations}
            teacher={data?.teacher}
          /> : <AppResult status={"info"} title={"Aucune séance"}></AppResult>
        ) : (
          isLoadingReservationsTeacher ? <Skeleton /> : !isLoadingReservationsTeacher && teacherReservations?.data?.length > 0 ? <SessionsCalendarGridView
            sessions={teacherReservations?.data}
            data={data}
            showFilter={true}
            showParticular={true}
            showAll={false}
          /> : <AppResult status={"info"} title={"Aucune séance"}></AppResult>
        )}
      </div>
    );
  }

  // Teacher Calendar tab - Calendar view
  else if (viewType === 'calendarTeacher') {
    return (
      <div className="group-classes-content">
        <div className="content-header">
          <Space style={{ justifyContent: 'space-between', width: '100%', flexWrap: 'wrap' }}>
            <Space style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'flex-start' }}>
              <Space>
                <Title level={4} style={{ margin: 0 }}>
                  Mes cours proposés
                </Title>
                <HelpPopover id={"classe"} />
              </Space>
              <Space>
                {courseView === 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('list')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue par liste
                </Button>}
                {courseView !== 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('calendar')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue calendrier
                </Button>}
              </Space>
            </Space>
          </Space>
        </div>

        {courseView === 'list' ? (
          <TeacherAvailability
            data={data}
            isCollective={isCollective}
            setCalendarData={setCalendarData}
            setLoadingCalendarData={setLoadingCalendarData}
            showReserved={false}
          />
        ) : (
          loadingCalendarData ? <Skeleton /> : !loadingCalendarData && calendarData?.length > 0 ? <SessionsCalendarGridView
            dayData={calendarData}
            data={data}
            showFilter={true}
            showParticular={false}
            showAll={false}
          /> : <AppResult status={"info"} title={"Aucune séance"}></AppResult>
        )}
      </div>
    );
  }

  else if (viewType === 'studentCalendarBooking') {
    return (
      <div className="group-classes-content">
        <div className="content-header">
          {isMobile ? <Space style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: 'center', width: '100%' }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: 'center', width: '100%' }}>
              <Space>
                <Title level={4} style={{ margin: 0 }}>
                  Cours réservés
                </Title>
                <HelpPopover id={"classe"} />
              </Space>

              <Button
                type="primary"
                size="middle"
                onClick={onShowHistory}
                className="classBtn classBtn-green"
                style={{ width: "150px" }}
              >
                Historique
              </Button>
            </div>

            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'center', width: '100%', margin: "10px auto" }}>
              <Space>
                {courseView === 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('list')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue par liste
                </Button>}
                {courseView !== 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('calendar')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue calendrier
                </Button>}
              </Space>

              {courseView !== 'calendar' && <Select
                value={filter}
                onChange={(value) => handleFilterStudent(value)}
                allowClear
                className="view-select-filter"
                placeholder={"Filtrer"}
              >
                <Option value="thisClass">Cette classe</Option>
                <Option value="otherClasses">Mes autres classes</Option>
                <Option value="particular">Mes cours particuliers</Option>
                <Option value="all">Tous mes cours</Option>
              </Select>}
            </div>
          </Space> : <Space style={{ justifyContent: 'space-between', width: '100%', flexWrap: 'wrap' }}>
            <Space style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'flex-start' }}>
              <Space>
                <Title level={4} style={{ margin: 0 }}>
                  Cours réservés
                </Title>
                <HelpPopover id={"classe"} />
              </Space>
              <Space>
                {courseView === 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('list')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue par liste
                </Button>}
                {courseView !== 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('calendar')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue calendrier
                </Button>}
              </Space>

              {courseView !== 'calendar' && <Select
                value={filter}
                onChange={(value) => handleFilterStudent(value)}
                allowClear
                className="view-select-filter"
                placeholder={"Filtrer"}
              >
                <Option value="thisClass">Cette classe</Option>
                <Option value="otherClasses">Mes autres classes</Option>
                <Option value="particular">Mes cours particuliers</Option>
                <Option value="all">Tous mes cours</Option>
              </Select>}
            </Space>

            <Button
              type="primary"
              size="middle"
              onClick={onShowHistory}
              className="classBtn classBtn-green"
              style={{ width: "150px" }}
            >
              Historique
            </Button>
          </Space>}
        </div>

        {courseView === 'list' ? (
          isLoadingReservationsStudent ? <Skeleton /> : !isLoadingReservationsStudent && filteredReservationsStudent?.length > 0 ? <SessionsListView
            sessions={filteredReservationsStudent}
            teacher={data?.teacher}
          /> : <AppResult status={"info"} title={"Aucune séance"}></AppResult>
        ) : (
          isLoadingReservationsStudent ? <Skeleton /> : !isLoadingReservationsStudent && studentReservations?.data?.length > 0 ? <SessionsCalendarGridView
            sessions={studentReservations?.data}
            data={data}
            showFilter={true}
            showParticular={true}
            showAll={true}
          /> : <AppResult status={"info"} title={"Aucune séance"}></AppResult>
        )}
      </div>
    );
  }

  else if (viewType === 'coursesPropositions') {
    return (
      <div className="group-classes-content">
        <div className="content-header">
          <Space style={{ justifyContent: 'space-between', width: '100%', flexWrap: 'wrap' }}>
            <Space style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'flex-start' }}>
              <Space>
                <Title level={4} style={{ margin: 0 }}>
                  Cours proposés
                </Title>
                <HelpPopover id={"classe"} />
              </Space>
              {/* <Space>
                {courseView === 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('list')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue par liste
                </Button>}
                {courseView !== 'calendar' && <Button
                  type={'default'}
                  onClick={() => setCourseView('calendar')}
                  style={{ borderRadius: '20px' }}
                >
                  Vue calendrier
                </Button>}
              </Space> */}
            </Space>
          </Space>
        </div>

        {courseView === 'list' ? (
          <TeacherCollectiveCalendar
            data={data}
            currentTeacher={data?.teacher}
            setCollectiveCalendarData={setCollectiveCalendarData}
          />
        ) : (
          collectiveCalendarData?.length > 0 ? <SessionsCalendarGridView
            dayData={collectiveCalendarData}
            data={data}
            showFilter={true}
            showParticular={true}
            showAll={false}
          /> : <AppResult status={"info"} title={"Aucune séance"}></AppResult>
        )}
      </div>
    );
  }

  else {
    return (
      <div style={{ display: "flex", flexDirection: "column", background: "#FFF", height: "auto", width: "100%", gap: "20px" }}>
        <div className="group-classes-content">
          <div className="content-header">
            <Space className="content-header-title-box">
              <Space className="content-header-title">
                <Title level={4} style={{ margin: 0 }}>
                  Challenges
                </Title>
                <HelpPopover id={"ma_classe_prefere_statistique_de_la_classe"} />
              </Space>
            </Space>

            {data?.teacher && <Button
              type="primary"
              size="middle"
              onClick={handleChallengesHistory}
              className="classBtn classBtn-green"
              style={{ width: "150px" }}
              loading={isFetchingChallengeData}
            >
              Historique
            </Button>}
          </div>

          <div style={{ padding: "10px 20px" }}>
            {pieData && pieData.length === 0 ? <div
              style={{
                borderRadius: "15px",
                padding: "0 5%",
                width: "100%"
              }}
            >
              <AppResult
                status="info"
                title={'Aucun challenge en cours !'}
              />
            </div> : barData && barData.length === 0 ? <div
              style={{
                borderRadius: "15px",
                padding: "0 5%",
                width: "100%"
              }}
            >
              <AppResult
                status="info"
                title={'Aucune donnée reçu pour le moment !'}
              />
            </div> : <div className="graphe-left">
              <div className="graphe-left-header">
                <div className="select">
                  <Select
                    placeholder="Challenge"
                    style={{ width: "100%" }}
                    bordered={false}
                    onChange={(e: any) => {
                      onSelectChallenge!(e);
                    }}
                    allowClear
                  >
                    {challenges?.map((challenge: any) => (
                      <Option key={challenge?._id} value={challenge?._id}>
                        {challenge?.title}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
              {/* update statistics dashboard */}

              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <div
                  style={{
                    width: "400px",
                    height: "300px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{ fontSize: isMobile ? "0.8em" : "14px" }}
                  >
                    Taux de participation
                  </div>
                  {/* <CercleChart pieData={barData} /> */}
                  <ChallengeChart pieData={barData} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "30px",
                    }}
                  >
                    <div style={{ fontSize: isMobile ? "0.8em" : "14px" }}>Participation : {Number(challengePercentage) % 1 === 0 ? Number(challengePercentage).toFixed(0) : Number(challengePercentage).toFixed(2)} %</div>
                  </div>
                </div>
                {pieData[0]?.total !== 0 && <div
                  style={{
                    width: "400px",
                    height: isMobile ? "auto" : "300px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    fontFamily: "var(--body-font)",
                    marginTop: isMobile ? "20px" : "0px"
                  }}
                >
                  <div
                    style={{ fontSize: isMobile ? "0.8em" : "14px" }}
                  >
                    Précision moyenne
                  </div>
                  <CercleChart pieData={pieData} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "30px",
                    }}
                  >
                    <div
                      style={{
                        color: "#80b1b2",
                        fontSize: isMobile ? "0.8em" : "14px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        gap: "10px"
                      }}
                    >
                      Bonne réponse
                      <div style={{ height: "10px", width: "10px", background: "#80b1b2" }}></div>
                    </div>{" "}
                    <div style={{
                      color: "#80b1b2",
                      fontSize: isMobile ? "0.8em" : "14px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: "10px"
                    }}>
                      Mauvaise réponse
                      <div style={{ height: "10px", width: "10px", background: "#b0e0e1" }}></div>
                    </div>
                  </div>
                </div>}
              </div>
            </div>}
          </div>
        </div>

        {pieData && barData && challengeStudents && <div className="group-classes-content">
          <div className="content-header">
            <Space className="content-header-title-box">
              <Space className="content-header-title">
                <Title level={4} style={{ margin: 0 }}>
                  Élèves et classement
                </Title>
                <HelpPopover id={"ma_classe_prefere_statistique_de_la_classe"} />
              </Space>

              <div className="search-box">
                <Input
                  placeholder="Chercher par mot-clé"
                  onChange={handleFilteringStudents}
                  style={{ maxWidth: 400, borderRadius: "16px !important" }}
                  size="large"
                  bordered={false}
                />
                <img src={SearchIcon} height={15} />
              </div>
            </Space>
          </div>

          {filteredChallengeStudents && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "90%", height: "auto", margin: "20px auto", paddingLeft: "20px", paddingRight: "20px" }}>
            <div style={{ width: "45%" }}>
              Élèves
            </div>
            <div style={{ width: "20%" }}>
              Points
            </div>
            <div style={{ width: "20%" }}>
              classement
            </div>
            <div style={{ width: "10%" }}>
              Actions
            </div>
          </div>}
          {filteredChallengeStudents && <div style={{ width: "90%", height: "1px", margin: "0px auto", background: "#C0C0C0", marginBottom: "20px" }}></div>}

          {filteredChallengeStudents ? filteredChallengeStudents?.map((student: any, index: number) => {
            return (
              <div className="user-row" key={index}>
                {/* Left */}
                <div className="user-info">
                  <img src={student?.profile || StudentAvatar} alt={student?.fullname} className="user-avatar" />
                  <span className="user-name">{student?.fullname}</span>
                </div>

                {/* Center */}
                <div className="user-stats">
                  <span className="user-stat">{student?.score}</span>
                  <span className="user-stat">{student?.classement}</span>
                </div>

                {data?.status === "PUBLISHED" && <Popover
                  visible={visibleOptions}
                  placement="left"
                  content={content}
                  trigger="click"
                  className="customPopover"
                >
                  <div ref={popoverReportRef} className="optionButton" onClick={(e: any) => { e.stopPropagation(); setVisibleOptions(!visibleOptions); setStudentId(student?.id) }}>
                    <img src={OptionsIcon} height={10} style={{ marginRight: "5px" }}></img>
                    Options
                  </div>
                </Popover>}
              </div>
            );
          }) : <AppResult status={"info"} title={"Aucun élève."} />}
        </div>}
      </div>
    );
  }

};

export default GroupClassesContent;
